/**
 * GrupsMunicipalsListing component.
 * @module components/View/GrupsMunicipalsListing
 */
import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hasBlocksData, getBaseUrl } from '@plone/volto/helpers';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { BodyClass, flattenToAppURL } from '@plone/volto/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { keys, isEmpty, map, filter } from 'lodash';
import { getSocialNetworkIcon } from '../../helpers'


const GrupsMunicipalsListing = (props) => {
    const { content, location } = props;
    const intl = useIntl();
    const dispatch = useDispatch();
    const groups = useSelector((state) => state.search.subrequests.groups?.items);
    const carrecs = useSelector((state) => state.search.subrequests.carrecs?.items);

    const getCarrec = (UID) => {
        if (!UID || !Array.isArray(carrecs)) return null;
        const carrec = carrecs.find((c) => c.UID === UID);
        return carrec?.title;
    }

    useEffect(() => {
        let contentFilter = {
            portal_type: ['GrupMunicipal'],
            sort_on: 'getObjPositionInParent',
            metadata_fields: ['hasPreviewImage', 'social_networks', 'spokesperson', 'deputy_spokesperson'],
            b_size: 1000,
        };
        dispatch(searchContent(flattenToAppURL(content['@id']), contentFilter, 'groups'));
    }, [dispatch]);

    useEffect(() => {
        let contentFilter = {
            portal_type: ['Carrec'],
            sort_on: 'getObjPositionInParent',
            metadata_fields: ['UID'],
            b_size: 1000,
        };
        dispatch(searchContent(flattenToAppURL(content['@id']), contentFilter, 'carrecs'));
    }, [dispatch]);

    const getNumberCarrecs = (group) => {
        if (!group || !carrecs) return 0;

        return carrecs.filter(
            (carrec) => carrec['@id'].startsWith(group['@id'] + '/'),
        ).length;
    };

    const formatCarrecsCount = (group) => {
        const count = getNumberCarrecs(group);
        return intl.formatMessage(
            {
                id: 'regidors',
                defaultMessage: `{count, plural,
                    one {# regidor}
                    other {# regidors}
                }`,
            },
            { count },
        );
    };

    return (
        <>
            <Container className=" ">
                {!isEmpty(groups) && (
                    <ul className="list-unstyled groupListing mt-4">
                        {groups.map((item) => (
                            <li className='groupListing__item' key={item['@id']}>

                                <article className='groupItem'>

                                    {item.image_field && (
                                        <PreviewImage
                                            className="groupItem__image"
                                            item={item}
                                            alt='' />
                                    )}

                                    <div className="groupItem__text">
                                        <h2 className='groupItem__name'>{item.title}</h2>
                                        <p className='groupItem__escons'>{formatCarrecsCount(item)}</p>
                                        {item?.description &&
                                            <p className='groupItem__desc mb-0'>{item.description}</p>
                                        }
                                        {(item?.spokesperson || item?.deputy_spokesperson) && (
                                        <dl className='pt-4 mt-3'>
                                            {item?.spokesperson && (
                                            <div className="grupMunicipal__details__item ">
                                                <dt className='fw-bold'><FormattedMessage id="Spokesperson" defaultMessage="Spokesperson" />:</dt>
                                                <dd className='ms-2'>{getCarrec(item.spokesperson)}</dd>
                                            </div>
                                            )}
                                            {item?.deputy_spokesperson && (
                                            <div className="grupMunicipal__details__item">
                                                <dt className='fw-bold'><FormattedMessage id="Deputy Spokesperson" defaultMessage="Deputy Spokesperson" />:</dt>
                                                <dd className='ms-2'>{getCarrec(item.deputy_spokesperson)}</dd>
                                            </div>
                                            )}
                                        </dl>
                                        )}

                                        <div className="groupItem__readMore mt-4">

                                            {!isEmpty(item?.social_networks) && (
                                                <>
                                                    <ul className='list-unstyled groupItem__xxss my-0'>
                                                        {map(item?.social_networks?.items, (social_network, index) => (
                                                            <li key={index} className='groupItem__xxss__item'>
                                                                <a className='groupItem__xxss__link' href={social_network.link} target="_blank" rel="noopener noreferrer">
                                                                    <FontAwesomeIcon icon={getSocialNetworkIcon(social_network.social_network)} />
                                                                    <span className="visually-hidden">{social_network.social_network}</span>
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </>
                                            )}
                                            <UniversalLink className="button ui flex-shrink-0 ms-auto" href={flattenToAppURL(item['@id'])}>
                                                <FormattedMessage id="See" defaultMessage="See" /> {item.title} <FormattedMessage id="in detail" defaultMessage="in detail" />
                                                <FontAwesomeIcon icon={faArrowRight} className='ms-2' />
                                            </UniversalLink>

                                        </div>
                                    </div>

                                </article>

                            </li>
                        ))}
                    </ul>
                )}
            </Container>
        </>
    );
};

export default GrupsMunicipalsListing;